import React, { FC } from 'react';
import { MasterSheetList as V2MasterSheetList } from '../../master-sheet-v2/views';
import { DRYWALL_CONFIG } from '../../master-sheet-v2/config';

export const MasterSheetList: FC<any> = props => (
  <V2MasterSheetList config={DRYWALL_CONFIG} {...props} />
);
